module.exports = "img/15.57b1a9.webp";